import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  where,
  Timestamp,
  getAggregateFromServer,
  sum,
  getCountFromServer
} from "firebase/firestore";
import { userUserStore } from "../stores/user";
import { pedidoConverter } from "@fixeduy/restaurantestypes";

export const useEstadisticasStore = defineStore("estadisticas", () => {
  const db = getFirestore();
  const userStore = userUserStore();

  const firestoreQuery = (
    fechaInicio: number,
    fechaFin: number,
    estado: string,
    //origen: "salon" | "takeaway" | "delivery" | ""
    sectorId: string
  ) => {
    const collectionRoute = `empresas/${userStore.empresa!.id}/pedidos/`;
    return query(
      collection(db, collectionRoute),
      where("fechaCreacion", ">=", fechaInicio),
      where("fechaCreacion", "<=", fechaFin),
      ...(estado === "cerrado"
        ? [where("estado", "==", "cerrado")]
        : [where("estado", "==", "abierto")]),
      ...(sectorId ? [where("sectorId", "==", sectorId)] : [])
    ).withConverter(pedidoConverter);
  };

  const getIngresos = async (
    fechaInicio: number,
    fechaFin: number,
    sectorId: string
    // origen: "salon" | "takeaway" | "delivery" | ""
  ) => {
    const q = firestoreQuery(fechaInicio, fechaFin, "cerrado", sectorId);

    const snapshot = await getAggregateFromServer(q, {
      total: sum("total")
    });

    const total = snapshot.data().total;

    return total;
  };

  const getTotalPedidos = async (fechaInicio: number, fechaFin: number) => {
    const q = firestoreQuery(fechaInicio, fechaFin, "cerrado", "");

    const snapshot = await getCountFromServer(q);

    const total = snapshot.data();

    return total.count;
  };

  const getPedidosAbiertos = async (fechaInicio: number, fechaFin: number) => {
    const q = firestoreQuery(fechaInicio, fechaFin, "abierto", "");

    const snapshot = await getCountFromServer(q);

    const total = snapshot.data();

    return total.count;
  };

  return { getIngresos, getTotalPedidos, getPedidosAbiertos };
});
